<template>
  <div class="min-h-screen w-full grid">
    <div
      v-loading="loading"
      element-loading-text="Avtorizatsiya tekshirilmoqda..."
    ></div>
  </div>
</template>

<script>
import axios from "axios";
import http from "@/http";
import { ElNotification } from "element-plus";

export default {
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    await this.fetchAccessToken();
  },
  methods: {
    async fetchAccessToken() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (!code) {
        console.error("Google'dan kod olinmadi!");
        return;
      }

      try {
        const response = await axios.post(
          "https://oauth2.googleapis.com/token",
          {
            client_id:
              "115536776507-5vt8qv662q7pc84skdk9ja9vkqsf28rn.apps.googleusercontent.com",
            client_secret: "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",
            redirect_uri: "https://snappy.uz/login/oauth2/code/google",
            grant_type: "authorization_code",
            code,
          }
        );

        const { access_token } = response.data;
        const { id_token } = response.data;
        const userResponse = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${access_token}` },
          }
        );

        const user = userResponse.data;
        let backendResponse;
        try {
          backendResponse = await http.post("/auth/google-login", {
            user,
            idToken: id_token,
          });
          // console.log(backendResponse);
          if (backendResponse.data.status === true) {
            localStorage.setItem("accessToken", backendResponse.data.token);
            localStorage.setItem(
              "refreshToken",
              backendResponse.data.refreshToken
            );
            this.$router.push("/main/home");
          } else {
            console.error("Backendda muammo yuz berdi");
          }
        } catch (error) {
          ElNotification({
            message: "Serverda xatolik !",
            type: "error",
            showClose: true,
            position: "top-right",
          });
        }
      } catch (error) {
        console.error("Google autentifikatsiya xatosi:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
